import { render } from "./AsyncComponnets.vue?vue&type=template&id=2e437af8"
import script from "./AsyncComponnets.vue?vue&type=script&lang=ts"
export * from "./AsyncComponnets.vue?vue&type=script&lang=ts"
script.render = render

export default script